export default __webpack_public_path__ + "static/media/review_2@3x.5d02d554.png";